import React from "react";
import { Link } from "react-router-dom";
import DataSender from "../lib/DataSender";
import { withAlert } from "react-alert";

import "./access.css";

class DtRead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dt_number: "",
    };
    this.alert = this.props.alert;
    this.ds = new DataSender();
    this.cancel = this.props.location.state.cancel
      ? this.props.location.state.cancel
      : "/Main";

    this.input = React.createRef();
  }

  dtFormmater = (e) => {
    if (e.key === "Enter") {
      this.requestAccess.apply(this);
      return;
    }
    let x = e.target.value
      .replace(/[^0-9]/g, "")
      .replace(/([0-9]{2})?([0-9]{8})$/, "$1-$2");
    this.setState({ dt_number: x });
    this.input.current.value = x;
  };

  requestAccess() {
    this.ds
      .accessDt(this.state.dt_number)
      .then((response) => response.json())
      .then((response) => {
        let to = this.props.location.state.to;
        this.props.history.push({
          pathname: to,
          state: { ...response },
        });
      })
      .catch(() => {
        this.alert.show("등록된 군번이 존재하지 않습니다.");
      });
  }

  render() {
    return (
      <div className="PhoneRead">
        <h1>군번을 입력해주세요</h1>
        <div className="wrapper">
          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="group">
              <input
                type="text"
                required="required"
                maxLength="11"
                onKeyUp={this.dtFormmater}
                name="dt_number"
                ref={this.input}
              />
              <span className="highlight"></span>
              <span className="bar"></span>
              <label>군번 ( 00 - 번호 )</label>
            </div>
          </form>
        </div>
        <div className="qrcreate-buttons">
          <div className="qrcreate-button1">
            <button className="button" onClick={this.requestAccess.bind(this)}>
              <p>입장하기</p>
            </button>
          </div>
          <Link to={this.cancel} className="qrcreate-button2">
            <button className="button">
              <p>취소</p>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default withAlert()(DtRead);
